import { render } from "./QuantityField.vue?vue&type=template&id=4b266417"
import script from "./QuantityField.vue?vue&type=script&lang=js"
export * from "./QuantityField.vue?vue&type=script&lang=js"

import exportComponent from "C:\\NicolPC\\VueWork2026\\Axxo\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__